module.exports = __webpack_public_path__ + "static/media/ExtendedWarranty.aa7b28b0.svg";